import React from 'react';
import { NotificationHistory } from 'model';

import { SVGAsset } from 'res';
import "./styles.css";
import "./mobile.css";

/**
 * @function NotificationsHistoryMonthContainer
 * @return {React.Component}
 * @param {STRING} month - the month that the notifications were altered
 * @param {DOUBLE} year - the year that the notifications were altered
 * @exported true
 * @description The container for the NotificationsHistoryWidget for each month.
 * @example
 * <NotificationsHistoryMonthContainer month="December" year="2022">
 *  <NotificationsHistoryWidget month="DEC" day="12" time="9:12 PM" icon="EnvelopeIcon" contactInfo="email@mail.com" message="Alert subscription was deleted" />
 * <NotificationsHistoryMonthContainer>
 */
export default function NotificationsHistoryMonthContainer(props) {
  const month = props.month ?? "[month]";
  const year = props.year ?? "0000";
  const point = props.dataPoint ?? "";

  return (
    <div className="notifications-history-month-container">
      <p className="date-text light-text">
        <span data-point={ point }>{month} {year}</span>
      </p>

      <div>
        {props.children}
      </div>
    </div>
  );
}

/**
 * @function NotificationsHistoryWidget
 * @return {React.Component}
 * @param {notificationHistory} item - The notification history item associated
 * @exported true
 * @description The row for each notification.
 * @example
 * <NotificationsHistoryWidget item={item}/>
 */
export function NotificationsHistoryWidget (props) {
  const historyItem = props.item ?? NotificationHistory.firstInstanceOf();
  const icon = historyItem.contactInfo.type === "email" ? "EnvelopeIcon" : "SquareMessageBubbleIcon";

  return (
    <div className="notifications-history-widget">
      <div className="flex-container notification-history-container">
        <div className="left-section set-width" data-point={ `Widget_Date_${ historyItem.id }`}>
          <div className="calendar text-center">
            <p className="month">{ historyItem.date.format("M") }</p>
            <p className="day">{ historyItem.date.format("d") }</p>
          </div>
        </div>
        <div className="flex-container align-center flex-width right-section" data-point={ `Widget_Contact_Info_${ historyItem.id }`}>
          <div className="flex-container flex-vertical flex-width align-top">
            <div className="flex-container flex-horizontal flex-width message-group">
              <p className="flex-width message">{ historyItem.name }</p>
              <div className="flex-container set-width align-center contact-group">
                <div className="contact-icon-container">
                  <SVGAsset id={ icon } />
                </div>
                <p className="light-text">{ historyItem.contactInfo.value }</p>
              </div>
            </div>
            <p className="sub-text light-text">{ historyItem.date.format("h:i p") }</p>
          </div>
        </div>
      </div>
    </div>
  );
}